import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    NOTIFY_CUSTOMER: createAsyncActionConstants('NOTIFY_CUSTOMER'),
    GET_REASON_CODES: createAsyncActionConstants('GET_REASON_CODES'),
    SEND_DERIGGING_REQUEST: createAsyncActionConstants('SEND_DERIGGING_REQUEST'),
    NOTIFY_CUSTOMER_FOR_CUSTOMS: createAsyncActionConstants('NOTIFY_CUSTOMER_FOR_CUSTOMS'),
    NOTIFY_CUSTOMER_FOR_DP: createAsyncActionConstants('NOTIFY_CUSTOMER_FOR_DP'),
};